module.exports = __webpack_public_path__ + "img/IMG_0797.ff5e6a38.png";